/*
 * @Author: your name
 * @Date: 2020-12-29 19:38:46
 * @LastEditTime: 2020-12-29 20:58:50
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /yunlizhi/货主端1.0/src/pages/orderManage/components/FormItem/minix.js
 */

export default {
    props: {
        propPrefix: {
            type: String,
            default: ''
        },
        prop: {
            type: String,
            default: ''
        }
    },
    computed: {
        propStr() {
            if (this.prop) {
                return this.prop
            }

            if (this.propPrefix) {
                return `${this.propPrefix}.${this.propName}`
            }

            return this.propName
        }
    }
}